import { render } from "./TelegramWelcome.vue?vue&type=template&id=c74b5844&scoped=true"
import script from "./TelegramWelcome.vue?vue&type=script&lang=js"
export * from "./TelegramWelcome.vue?vue&type=script&lang=js"

import "./TelegramWelcome.vue?vue&type=style&index=0&id=c74b5844&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c74b5844"]])

export default __exports__